import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { find, get, map, isEmpty, isNull } from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage, FormattedNumber, injectIntl, intlShape } from 'react-intl';
import classnames from 'classnames';
import { formValueSelector, change } from 'redux-form';

import { reduxForm, Field, getFormValues } from 'redux-form';
import { REVIEW_OFFER_FORM } from '../../app-main/components/reduxForms/constants/formNames';
import { getShowBillingForm, showBkgReqFormError } from '../../app-bookings-request/forms/bookingUtil';
import validateReviewOfferForm from './validate/validateReviewOfferForm';
import submitReviewOfferForm from './submit/submitReviewOfferForm';

import Table from '../../elements-table/table';
import { Link } from 'react-router';
import TextButton from '../../elements-buttons/text-button';
import Button from '../../elements-buttons/Button';
import { TosCTAdisclaimer } from 'shared-components/terms/cta-disclaimer';
import ToggleField from '../../app-main/components/reduxForms/fields/ToggleField/ToggleField';
import ApplyCreditField from '../../app-main/components/reduxForms/fields/ApplyCreditField/ApplyCreditField';
import CheckboxField from 'shared-components/reduxForms/fields/CheckboxField/CheckboxField';
import { Payment } from '../../elements-forms/payment-old';
import { IdentityVerification } from '../../elements-forms/identity-verification';
import ModalManager from '../../elements-modal/modal-manager-v2';
import { PaymentErrorModal } from '../modals/payment-error-modal';
import { DeclineOfferModal } from '../modals/decline-offer-modal';
import { ConfirmDeclineOfferModal } from '../modals/confirm-decline-offer-modal';
import CurrentDetailsContainer from '../../app-main/containers/CurrentDetailsContainer';
import { CancellationPolicySection } from '../../app-bookings-request/cancellation-policy-section';
import SocialEventPolicyCheckbox from '../../app-bookings-request/SocialEventPolicyCheckbox';
import HostRulesAgree from '../../app-bookings-request/HostRulesAgree';
import { TaxesBillingAddress } from '../../app-bookings-request/TaxesBillingAddress';
import { fetchOwnerSpacesInfo } from '../../app-main/actions/spaces';
import CheckboxFieldPanel from 'shared-components/reduxForms/utilities/CheckboxFieldPanel';
import SharedIntlProviderHOC from '../../shared-components/hocs/sharedIntlProviderHOC';

class ReviewOfferForm extends Component {
  constructor(props) {
    super(props)

    this.isIDVInViewport = this.isIDVInViewport.bind(this);

    this.state = {
      has_rendered_with_verification: false,
      has_seen_verification: false,
      has_clicked_verification: false
    };
  }

  componentDidMount () {
    const { dispatch, accessToken, ssoId } = this.props;

    dispatch(fetchOwnerSpacesInfo(`owner/${ssoId}`, accessToken));
  }

  componentDidUpdate (prevProps, prevState) {
    const { has_seen_verification, has_clicked_verification, has_rendered_with_verification } = this.state;
    const { guestNeedsVerification, booking, listing, publicAddOns = [], alcoholConsumed, schedule, riskScore } = this.props;
    const hasAnalytics = 'object' === typeof analyticsIntegrations;
    const needsVerificationAnalytics = has_seen_verification !== prevState.has_seen_verification || has_clicked_verification !== prevState.has_clicked_verification;
    const alcoholChanged = alcoholConsumed && alcoholConsumed !== prevProps.alcoholConsumed;

    const contracts = [
      get(booking, 'booking.master', {}),
      ...get(booking, 'booking.children', [])
    ];

    // bc of the way props are threaded to this component, guestNeedsVerification is undefined on mount, then switched to true/false on the next render
    if (guestNeedsVerification && hasAnalytics) {
      const analytics_payload = {
        viewed: has_seen_verification,
        clicked: has_clicked_verification,
        booking_request_review: false,
        custom_offer_review: true,
        contracts,
        listingObj: listing,
        publicAddOns,
        alcohol_consumed: alcoholConsumed,
        schedule,
        riskScore
      }
      if (needsVerificationAnalytics) { // if either state value has changed
        analyticsIntegrations.reviewIdentityVerification(analytics_payload);
        return; // don't hit next conditional and double send analytics
      }
      if (!has_rendered_with_verification) { // essentially capturing the second render
        document.addEventListener('scroll', this.isIDVInViewport); // add event listener here once IDV is rendered
        analyticsIntegrations.reviewIdentityVerification(analytics_payload);
        this.setState({
          has_rendered_with_verification: true
        });
      }
    }

    // If alcohol changes, we trigger a request to see if user needs IDV
    if (alcoholChanged) {
      this.props.getIDVInfo(alcoholConsumed)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.isIDVInViewport); // remove event listener regardless when they leave page
  };

  isIDVInViewport() { // gets called on scroll until the component state is set { has_seen_verification: true }
    const el = document.getElementById('identity_verification_container'); // selects dom element for container of the IDV header, description, button, errors, etc.
    const rect = el.getBoundingClientRect(); // returns essentially coordinates from top-left of viewport to selected element
    const isVisible = rect.top >= 0 && // top of element is below top edge of viewport
                      rect.left >= 0 && // left of element is right of left edge of viewport
                      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && // bottom is above bottom edge
                      rect.right <= (window.innerWidth || document.documentElement.clientWidth) // right is left of right edge
    if (isVisible) {
      this.setState({
        has_seen_verification: true // trigger analytics event on state change saying user has seen the verification field
      }, () => document.removeEventListener('scroll', this.isIDVInViewport)); // remove event listener so this fn is no longer called
    }
  };

  render() {
    const {
      dispatch,
      currency,
      spaceRentalTotal = 0,
      total = 0,
      guestFee = 0,
      accessToken,
      booking = {},
      declineOfferAction = null,
      discounts = {},
      iosWebView = false,
      scrollTopIOS = null,
      closeIOSModal = null,
      updateDifference = {},
      currentBookingTotal = 0,
      isHostUpdate = false,
      routeParams = {},
      finalCb = null,
      itemsArray = [],
      contracts = [],
      handleSubmit,
      redirectToInboxDetails,
      whichModal,
      paymentErrorMsg,
      displayError,
      ccProcessing,
      selectedPayment,
      paymentInfo,
      isProcessing = false,
      toggleModal = null,
      handleListClickCb = null,
      storeCardInstance = null,
      handleDeclineOfferClick = null,
      paymentActionFn = null,
      creditBalance = 0,
      handleApplyCreditChange = null,
      applyCreditProcessing = null,
      creditsApplied = false,
      remainingGuestTotal = null,
      noAddtlPaymentNeeded = true,
      refundedAmount = null,
      currentPaidTotal,
      psCreditsAllowed,
      socialEventPolicyAgreementRequired,
      socialEventsPolicyCopy,
      ssoId,
      guestNeedsVerification = false,
      alcoholConsumed,
      listing = {},
      intl,
      feeProfiles,
      genericError = '',
      allCountries = [],
      billingCountryValue,
      initialValues,
      spaces,
      cancellationPolicies,
      schedule,
      remainingSplitPaymentRequired,
      isSplitPayment,
      splitPaymentFee,
      handleBillingCountryChange,
      handleBillingSubRegionChange,
      guestSpaceCountry,
      profile,
      masterContract
    } = this.props;

    const getIdentityValue = (value) => dispatch(change(REVIEW_OFFER_FORM, 'identity_verification', value));

    const onIDVClick = (e) => {
      if (!this.state.has_clicked_verification) {
        this.setState({ has_clicked_verification: true })
      }
    }

    const tableHeaders = [
      { label: 'Price' }
    ];

    // signals if offer came from booking request (previous cc auth)
    const fromBookingRequest = currentPaidTotal > 0;
    // refund amount from host update or previous cc auth
    const refundTotal = -refundedAmount;
    // hide additional payment if credits not applied for offer w/out previous cc auth or if there is a refund
    const hideAddtlPaymentAmount = (!creditsApplied && !fromBookingRequest && !isHostUpdate) || !!refundTotal;
    // show payment section if there is no additional payment (before credits applied) & payment info is loaded
    const showPaymentSection = (0 < remainingGuestTotal || !!creditsApplied || remainingSplitPaymentRequired) && paymentInfo;

    const cancellationPolicy = get(booking, 'cancellation_policy', {});
    const cancellationPoliciesLocalized = get(cancellationPolicies, 'cancellation_policies', {}) ;
    const cancellationPolicyLocalized = _.find(cancellationPoliciesLocalized, {id: cancellationPolicy.id}) || cancellationPolicy;
    const cancellationPolicyDesc = cancellationPolicyLocalized.short_description || cancellationPolicyLocalized.description;

    const listingObj = get(booking, 'listing', {});
    const productionDetails = get(listingObj, 'production_details', {});
    const isProductionListing = 'Production' === get(listingObj, 'use_type');
    const hostRulesData = {
      listingRules: get(listingObj, 'rules', ''),
      min_age: get(listingObj, 'min_age', ''),
      ...(isProductionListing && productionDetails),
      surveillanceData: get(listingObj, 'surveillance_info', {})
    };

    const billingAddress = get(feeProfiles, 'billingAddress.data', []);
    const displayBillingDropdown = getShowBillingForm(billingAddress);

    const { metro, country } = listing;

    const masterCalculations = get(masterContract, 'calculations', {});
    const hostAddOnsSummary = get(masterCalculations, 'host_add_ons_summary', {});

    const isHost = masterContract?.host_sso_id === profile?.SSOid;

    const getSafeValue = (value, defaultValue = 0) =>
      !isNaN(+value) ? value : defaultValue;

    const displayedSpaceRentalTotal =
      !isHost && masterCalculations?.space_rental_guest_with_tax !== undefined
        ? getSafeValue(masterCalculations.space_rental_guest_with_tax)
        : getSafeValue(spaceRentalTotal);

    const displayedAddOnsTotal = isHost
      ? get(hostAddOnsSummary, 'amount', 0)
      : getSafeValue(
          masterCalculations?.add_ons_guest_with_tax,
          getSafeValue(masterCalculations?.add_ons_guest)
        );

    const displayedSubtotal = getSafeValue(
      displayedSpaceRentalTotal + displayedAddOnsTotal
    );

    return (
      <form onSubmit={handleSubmit}>
        <div className="review-offer-form margin-lg-bottom">
          <ModalManager whichModal={whichModal} toggleModal={toggleModal}>
              <div id="CurrentDetailsContainerModal" className="current-details-ios-modal">
                {iosWebView && (
                  <CurrentDetailsContainer
                    booking={booking}
                    accessToken={accessToken}
                    iosWebView={iosWebView}
                    scrollTopIOS={scrollTopIOS}
                    toggleModal={toggleModal}
                    whichModal={whichModal}
                    routeParams={routeParams}
                  />
                )}
              </div>
            <PaymentErrorModal
              id="paymentErrorModal"
              errorMsg={paymentErrorMsg}
              whichModal={whichModal}
            />

            <DeclineOfferModal
              id="declineOfferModal"
              accessToken={accessToken}
              bookingID={booking._id}
              declineOfferAction={declineOfferAction}
              isUpdate={isHostUpdate}
              iosWebView={iosWebView}
              scrollTopIOS={scrollTopIOS}
              closeIOSModal={closeIOSModal}
              whichModal={whichModal}
              finalCb={finalCb}
              booking={booking}
              contracts={contracts}
            />

            <ConfirmDeclineOfferModal
              id="confirmDeclineOfferModal"
              bookingId={booking._id}
              declineOfferAction={declineOfferAction}
              toggleModal={toggleModal}
              iosWebView={iosWebView}
              scrollTopIOS={scrollTopIOS}
              closeIOSModal={closeIOSModal}
              whichModal={whichModal}
            />
          </ModalManager>
          <Table
            tableHeaders={tableHeaders}
            tableBody={
              <div>
                <div className="flex space-between table-row">
                  <div>
                    <FormattedMessage
                      id="inbox_review_offer.review_offer_form.space_rental"
                      defaultMessage="Space rental total"
                    />
                  </div>
                  <div data-testing-id="space-rental-amount">
                    <FormattedNumber
                      value={displayedSpaceRentalTotal}
                      currency={currency}
                      style={"currency"}
                    />
                  </div>
                </div>

                { !isEmpty(itemsArray) &&
                <div className="flex space-between table-row">
                  <div>
                    <FormattedMessage
                      id="inbox_review_offer.review_offer_form.addons"
                      defaultMessage="Add-ons total"
                    />
                  </div>
                  <div data-testing-id="add-ons-total">
                    <FormattedNumber
                      value={displayedAddOnsTotal}
                      currency={currency}
                      style={"currency"}
                    />
                  </div>
                </div>
                }

                <hr className="dotted margin-md-top margin-md-bottom" />

                { map(discounts, (discount) => {
                  const { value, title, max_amount, discount_str, apply_as, discount_amount } = discount;
                  const discountDescription = ("PERCENT_OFF" === apply_as)
                    ? <FormattedMessage id="inbox_review_offer.review_offer_form.percent_off" defaultMessage="{value}% off" values={{ value: value }} />
                    : <FormattedMessage
                      id="inbox_review_offer.review_offer_form.value_off"
                      defaultMessage="{value} off"
                      values={{
                        value: <FormattedNumber
                          value={value}
                          currency={currency}
                          style={"currency"}
                        />
                      }}
                    />;
                  const maxAmountDescripton = max_amount
                    ? <FormattedMessage
                      id="inbox_review_offer.review_offer_form.max_amount"
                      defaultMessage=", up to {amount}"
                      values={{
                        amount: <FormattedNumber
                          value={max_amount}
                          currency={currency}
                          style="currency"
                        />
                      }}
                    />
                    : "";
                  return (
                    <div className="flex space-between table-row discount-row">
                      { discount_str ? <div>{discount_str}</div> :
                        <div>
                          <div>{title}</div>
                          <div>{`(${discountDescription}${maxAmountDescripton})`}</div>
                        </div>
                      }
                      <div>
                        -<FormattedNumber value={discount_amount} currency={currency} style={"currency"} />
                      </div>
                    </div>
                  );
                })}

                <div className="flex space-between table-row">
                  <div>
                    <FormattedMessage
                      id="inbox_review_offer.review_offer_form.subtotal"
                      defaultMessage="Subtotal"
                    />
                  </div>
                  <div>
                    <FormattedNumber value={displayedSubtotal} currency={currency} style={"currency"} />
                  </div>
                </div>

                <div className="flex space-between table-row">
                  <div>
                    <FormattedMessage
                      id="inbox_review_offer.review_offer_form.processing_fee"
                      defaultMessage="Processing fee"
                    />
                  </div>
                  <div>
                    <FormattedNumber value={guestFee} currency={currency} style={"currency"} />
                  </div>
                </div>

                { isSplitPayment &&
                <div className="flex space-between table-row">
                  <div>
                    <FormattedMessage
                      id="inbox_review_offer.review_offer_form.pnpl_fee"
                      defaultMessage="Part now, part later fee"
                    />
                  </div>
                  <div>
                    <FormattedNumber value={splitPaymentFee} currency={currency} style="currency" />
                  </div>
                </div> }

                <hr className="dotted margin-md-top margin-md-bottom" />

                <div className={classnames("flex space-between table-row", { "heavy": !currentPaidTotal })}>
                  <div>
                    <FormattedMessage
                      id="inbox_review_offer.review_offer_form.total"
                      defaultMessage="Total"
                    />
                  </div>
                  <div>
                    <FormattedNumber value={total} currency={currency} style={"currency"} />
                  </div>
                </div>

                { isHostUpdate &&
                <div className="flex space-between table-row">
                  <div>
                    <span className="margin-lg-right">
                      <FormattedMessage
                        id="inbox_review_offer.review_offer_form.current_total"
                        defaultMessage="Current total"
                      />
                    </span>
                    { iosWebView ?
                      <span>
                        <TextButton
                          id="see-current-details-button"
                          buttonText={ intl.formatMessage({ id: "inbox_review_offer.review_offer_form.see_details_button", defaultMessage: "See details" }) }
                          iconPosition="right"
                          onClick={() => { toggleModal("CurrentDetailsContainerModal"); }}
                        />
                      </span> :
                      <Link to={`current-details`} target="_blank">
                        <FormattedMessage
                          id="inbox_review_offer.review_offer_form.see_details"
                          defaultMessage="See details"
                        />
                      </Link>
                    }
                  </div>
                  <div>
                    <FormattedNumber value={currentBookingTotal} currency={currency} style={"currency"} />
                  </div>
                </div>
                }

                { !!currentPaidTotal && !isHostUpdate &&
                <div className="table-row">
                  <div className="flex space-between">
                    <div className="title-field">
                      <span className="margin-md-right">
                        <FormattedMessage
                          id="inbox_review_offer.review_offer_form.previous_payment"
                          defaultMessage="Previous payment"
                        />
                      </span>
                    </div>
                    <div data-testing-id="processing-amount">
                      -<FormattedNumber value={currentPaidTotal} currency={currency} style={"currency"} />
                    </div>
                  </div>
                </div> }

                { !!creditsApplied &&
                <div className="table-row">
                  <div className="flex space-between text-green">
                    <div className="title-field">
                      <span className="margin-md-right">
                        <FormattedMessage
                          id="inbox_review_offer.review_offer_form.credits"
                          defaultMessage="Credits"
                        />
                      </span>
                    </div>
                    <div data-testing-id="processing-amount">
                      -<FormattedNumber value={creditsApplied} currency={currency} style={"currency"} />
                    </div>
                  </div>
                </div> }

                { !hideAddtlPaymentAmount &&
                <div className="flex space-between table-row heavy">
                  <div>
                    <FormattedMessage
                      id="inbox_review_offer.review_offer_form.additional_payment"
                      defaultMessage="Additional payment"
                    />
                  </div>
                  <div>
                    <FormattedNumber value={remainingGuestTotal} currency={currency} style={"currency"} />
                  </div>
                </div>
                }

                { !!refundTotal &&
                <div className="guest-review-offer-payment">
                  <div className="flex space-between table-row margin-lg-bottom heavy">
                    <div>
                      <FormattedMessage
                        id="inbox_review_offer.review_offer_form.refund"
                        defaultMessage="Refund"
                      />
                    </div>
                    <div className="text-green">
                      <FormattedNumber value={refundTotal} currency={currency} style={"currency"} />
                    </div>
                  </div>
                  <p>
                    <FormattedMessage
                      id="inbox_review_offer.review_offer_form.will_be_refunded"
                      defaultMessage="You will be refunded the amount displayed upon clicking Accept Offer. The refund will be paid to the original payment method."
                    />
                  </p>
                </div>
                }
              </div>
            }
          />

          { !isHostUpdate &&
            <div>
              <hr style={{ marginTop: 40 }} />

              <CancellationPolicySection
                policyName={cancellationPolicyLocalized.name}
                policyDescription={cancellationPolicyDesc}
                gracePeriodApplies={cancellationPolicy.grace_period_applies}
              />

              <hr className="full-width margin-md-top" style={{ marginBottom: 40 }} />

              { socialEventPolicyAgreementRequired &&
                <SocialEventPolicyCheckbox socialEventsPolicyCopy={socialEventsPolicyCopy} />
              }

              <div>
                <HostRulesAgree hostRulesData={hostRulesData} />
                <div className="flex">
                  <Field
                    id="accept-rules"
                    name="are_host_rules_accepted"
                    attributes={{ "data-testing-id": "host-rules-checkbox" }}
                    component={CheckboxFieldPanel}
                    label={ intl.formatMessage({ id: "inbox_review_offer.review_offer_form.accept_rules", defaultMessage: "I accept and understand these host rules and disclosures." }) }
                    option={true}
                  />
                </div>
              </div>
              <hr className="large-hr-margin" />
            </div>
          }

        <div className="flex column alcohol-toggle-section margin-xl-bottom margin-xl-top">
          <div className="heavy margin-md-bottom">
            <FormattedMessage
              id="inbox_review_offer.review_offer_form.alcohol_consumed"
              defaultMessage="Will alcohol be consumed?"
            />
          </div>
          <Field
            name="alcohol_consumed"
            component={ToggleField}
            attributes={{
              "data-testing-id": "alcohol-consumed-toggle",
              name: "alcohol_consumed"
            }}
            firstOption={
              {
                id: "alcohol-consumed-true",
                value: "true",
                label: intl.formatMessage({ id: "inbox_review_offer.review_offer_form.alcohol_yes", defaultMessage: "Yes" })
              }}
            secondOption={
              {
                id: "alcohol-consumed-false",
                value: "false",
                label: intl.formatMessage({ id: "inbox_review_offer.review_offer_form.alcohol_no", defaultMessage: "No" })
              }
            }
          />
        </div>

        <hr className="large-hr-margin" />

        {displayBillingDropdown &&
          <>
            <TaxesBillingAddress
              intl={intl}
              feeProfiles={feeProfiles}
              allCountries={allCountries}
              billingCountryValue={billingCountryValue}
              defaultCountry={guestSpaceCountry}
              onChangeFn={handleBillingCountryChange}
              onSubRegionChange={handleBillingSubRegionChange}
            />
            <hr className="large-hr-margin" />
          </>
        }

        { showPaymentSection &&
          <div className="flex column">
            <div className="flex middle h6 no-top-margin">
              <img className="icon margin-md-right" src="https://assets.peerspace.com/credit-card.svg?v=rb" alt={ intl.formatMessage({ id: "inbox_review_offer.review_offer_form.credit_card_icon", defaultMessage: "Credit Card Icon" }) } />
              <span>
                <FormattedMessage
                  id="inbox_review_offer.review_offer_form.payment"
                  defaultMessage="Payment"
                />
              </span>
            </div>
            <div className="heavy margin-sm-bottom">
              <FormattedMessage
                id="inbox_review_offer.review_offer_form.credit_card"
                defaultMessage="Credit Card"
              />
            </div>
            <Field
              name={selectedPayment ? "payment" : "cardholders_name"}
              component={Payment}
              paymentInfo={paymentInfo}
              useBootstrapGrid={false}
              actionFn={paymentActionFn}
              handleListClickCb={handleListClickCb}
              returnStripeCardInstance={storeCardInstance}
              inReduxForm
            />
            { (!!creditBalance && psCreditsAllowed) &&
              <div className="apply-credit-section margin-md-top margin-lg-bottom">
                <div className="heavy">
                  <FormattedMessage
                    id="inbox_review_offer.review_offer_form.peerspace_credits"
                    defaultMessage="Peerspace Credits"
                  />
                </div>
                <Field
                  name="apply_credit"
                  component={ApplyCreditField}
                  currency={currency}
                  creditBalance={creditBalance}
                  onChange={handleApplyCreditChange}
                  isProcessing={applyCreditProcessing}
                  creditsApplied={creditsApplied}
                />
              </div> }
            <hr className="large-hr-margin" style={{ marginTop: 28 }} />
          </div>
        }

        { guestNeedsVerification &&
          <div className="identitify-verification-section margin-xl-bottom" id="identity_verification_container">
            <div className="flex space-between margin-lg-bottom">
              <div>
                <div className="flex middle h6 no-top-margin">
                  <img className="icon margin-md-right" src="https://assets.peerspace.com/verified-outline.svg?v=rb" alt="Verification Icon" />
                  <span>
                    <FormattedMessage
                      id="inbox_review_offer.review_offer_form.verify_your_identity"
                      defaultMessage="Verify your identity"
                    />
                  </span>
                </div>
                <div className="help-block no-top-margin text-base">
                  <FormattedMessage
                    id="inbox_review_offer.review_offer_form.trust_safety_message"
                    defaultMessage="Trust and safety is our top priority and to keep our community safe all new Peerspace customers must verify their identity. We’ve partnered with Stripe for a seamless verification experience.  Identity verification must be completed on the Peerspace account holder."
                  />
                </div>
                <div className="margin-lg-top">
                  <Field
                    id="identity_verification"
                    name="identity_verification"
                    component={IdentityVerification}
                    ssoId={ssoId}
                    accessToken={accessToken}
                    triggerId={listing._id}
                    triggerType="listing"
                    getIdentityValue={getIdentityValue}
                    alcoholConsumed={alcoholConsumed}
                    analyticsOnClick={onIDVClick}
                    metro={metro}
                    country={country}
                  />
                </div>
              </div>
            </div>

            <hr className="large-hr-margin" />
          </div>
        }


        <div className="help-block text-danger text-left">{ displayError }</div>
        <div className="flex space-between column-xs-reverse btn-container margin-xl-bottom">
          <Button
            type="button"
            className="btn btn-default classic"
            onClick={redirectToInboxDetails}
          >
            <FormattedMessage
              id="inbox_review_offer.review_offer_form.cancel_button"
              defaultMessage="Cancel"
            />
          </Button>

          <div className="flex space-between column-xs-reverse">
            <Button
              type="button"
              className="btn btn-default classic decline-btn margin-sm-right"
              onClick={handleDeclineOfferClick}
            >
              <FormattedMessage
                id="inbox_review_offer.review_offer_form.decline_offer"
                defaultMessage="Decline"
              />
            </Button>

            <Button
              type="submit"
              category="primary"
              isLoading={isProcessing}
              disabled={isProcessing}
            >
              <FormattedMessage
                id="inbox_review_offer.review_offer_form.accept_offer"
                defaultMessage="Accept and pay"
              />
            </Button>
          </div>
        </div>

        <TosCTAdisclaimer location="acceptBkgNewTab" buttonLabel={ intl.formatMessage({ id: "inbox_review_offer.review_offer_form.accept_offer_label", defaultMessage: "Accept Offer" }) } />

      </div>
    </form>);
  }
}

ReviewOfferForm.propTypes = {
  booking: PropTypes.object,
  accessToken: PropTypes.string,
  ssoId: PropTypes.string,
  total: PropTypes.number,
  spaceRentalTotal: PropTypes.number,
  guestFee: PropTypes.number,
  currencySymbol: PropTypes.string,
  redirectToInboxDetails: PropTypes.func,
  declineOfferAction: PropTypes.func,
  discounts: PropTypes.array,
  iosWebView: PropTypes.bool,
  scrollTopIOS: PropTypes.func,
  closeIOSModal: PropTypes.func,
  currency: PropTypes.string,
  isHostUpdate: PropTypes.bool,
  updateDifference: PropTypes.object,
  currentBookingTotal: PropTypes.number,
  routeParams: PropTypes.object,
  finalCb: PropTypes.func,
  contracts: PropTypes.array,
  itemsArray: PropTypes.array,
  intl: intlShape,
  feeProfiles: PropTypes.array,
  allCountries: PropTypes.array,
  remainingSplitPaymentRequired: PropTypes.bool
};

const config = {
  form: REVIEW_OFFER_FORM,
  onSubmit: submitReviewOfferForm,
  validate: validateReviewOfferForm,
  onSubmitFail: showBkgReqFormError,
  enableReinitialize: true
};

const selector = formValueSelector(REVIEW_OFFER_FORM);

function mapStateToProps (state) {
  const { contract, env, feeProfiles, profile, space } = state;
  const identityValue = selector(state, 'identity', {});
  const billingCountryValue = selector(state, 'billing_country');
  const currentSpaceRental = find(get(contract, 'data.contracts'), { type: 'SPACE_RENTAL' }) || {};
  const alcoholConsumed = get(currentSpaceRental, 'meta.booking.alcohol_consumed');
  const billingAddress = get(feeProfiles, 'billingAddress.data', []);
  const values = getFormValues(REVIEW_OFFER_FORM)(state);
  const cancellationPolicies = get(env, 'spaces', null);
  const guestSpaceCountry = get(space, 'data.countryStatus.country', '');
  const activeBillingAddress = find(billingAddress, (address) => {
    return 'ACTIVE' === address.obj_state;
  }) || {};
  const locale = SharedIntlProviderHOC.getLocale();
  const localeCountry = locale.split('-')[1];

  return {
    initialValues: {
      alcohol_consumed: alcoholConsumed === null ? null : alcoholConsumed ? 'true' : 'false',
      billing_country: activeBillingAddress.country || guestSpaceCountry || localeCountry,
      billing_city: activeBillingAddress.city,
      billing_state: activeBillingAddress.state,
      billing_street: activeBillingAddress.street,
      billing_unit: activeBillingAddress.unit,
      billing_zip: activeBillingAddress.zip
    },
    identityValue,
    billingCountryValue,
    guestSpaceCountry,
    alcoholConsumed: values?.alcohol_consumed,
    cancellationPolicies,
    profile
  };
}

export default injectIntl(connect(mapStateToProps)(reduxForm(config)(ReviewOfferForm)));
